import { createFileRoute } from "@tanstack/react-router";
import NewHopeChronicPainNoOpioidsPage from "@/pages/articles/NewHopeChronicPainNoOpioidsPage";
export const Route = createFileRoute("/new-hope-chronic-pain-no-opioids")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Chronic Pain Without Opioids | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Discover cutting-edge non-opioid chronic pain treatments in Coral Springs, FL. Learn how IV Ketamine infusion recalibrates central pain pathways for CRPS.",
        },
        {
          property: "og:title",
          content: "Chronic Pain Without Opioids | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Discover cutting-edge non-opioid chronic pain treatments in Coral Springs, FL. Learn how IV Ketamine infusion recalibrates central pain pathways for CRPS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/new-hope-for-treating-chronic-pain-without-opioids-in-florida",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/new-hope-for-treating-chronic-pain-without-opioids-in-florida",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NewHopeChronicPainNoOpioidsPage />;
}
